import { i18nService } from "services";
import { IFieldType, IFormSchema } from "types";

import { INewsletterOption } from "types";

export const makeSchema = (
  id: string,
  newsletters: INewsletterOption[]
): IFormSchema => ({
  disableAfterSubmit: true,
  fields: [
    {
      name: `email_${id}`,
      label: i18nService.copy["newsletter.email"],
      type: IFieldType.text,
      validation: {
        required: i18nService.copy["form.required"],
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i,
          message: i18nService.copy["form.invalidEmail"],
        },
      },
    },
    {
      name: `audiences_${id}`,
      type: IFieldType.checkboxGroup,
      label: i18nService.copy["newsletter.audiencesLabel"],
      options: newsletters.map(({ title, id }) => ({
        type: IFieldType.checkbox,
        name: id,
        label: title,
        value: id,
      })),
      validation: {
        required: i18nService.copy["form.requiredCheckbox"],
      },
    },
    {
      name: `optin_${id}`,
      type: IFieldType.checkbox,
      label: i18nService.copy["newsletter.optin"],
      validation: {
        required: i18nService.copy["form.required"],
      },
    },
  ],
});
